"use strict";
import Account from "../../api/account";
import CarrierName from "../carrier_name";
import "../../services/carrier_service";
import classNames from "classnames";
import HoverableValueTable from "../hoverable_value_table";
import moment from "moment";
import referenceHelpers from "../../helpers/references";
var LoadTable = React.createClass({
  getInitialState: function() {
    return {
      cssClass: "import-detail__load-table",
      config: {
        columns: {
          load_id: { name: "Load ID" },
          status: { name: "Status" },
          carrier_name: { name: Account.carrierTerm() },
          shipped: { name: "Shipped" },
          carrier_charge: { name: "Amount" },
          origin: { name: "Origin" },
          destination: { name: "Destination" }
        }
      }
    };
  },
  currency: function(string) {
    if (!_.str.isBlank(string)) {
      return "$" + _.str.numberFormat(parseFloat(string), 2);
    }
  },
  address: function(item, prefix) {
    if (item[prefix + "_city"] && item[prefix + "_state"]) {
      return item[prefix + "_city"] + ", " + item[prefix + "_state"];
    } else if (item[prefix + "_name"]) {
      return item[prefix + "_name"];
    }
  },
  date: function(item) {
    if (item) {
      return moment(item).format("L");
    }
  },
  isHighlighted: function(load) {
    return this.props.highlightedLoads.indexOf(load.id) >= 0;
  },
  cssClasses: function(load) {
    return classNames({
      "import-detail__load-table__matched": this.isHighlighted(load)
    });
  },
  references: function(item) {
    return referenceHelpers.allReferences(item);
  },
  loadIdFormat: function(item) {
    if (item.source_system === "hubtran" && item.load_id.includes("dummy")) {
      return "DRAFT LOAD";
    } else {
      return item.load_id;
    }
  },
  format: function(loadStates) {
    var self = this;
    return _.map(loadStates, function(loadState) {
      var item = loadState.load;
      return {
        load_id: this.loadIdFormat(item),
        status: item.status,
        pickup_reference: item.pickup_reference,
        carrier_name: item.carrier_id ? /* @__PURE__ */ React.createElement(CarrierName, { carrierID: item.carrier_id }) : null,
        shipped: self.date(item.actual_shipped_at),
        carrier_charge: self.currency(item.carrier_charge),
        carrier_id: item.carrier_id,
        origin: self.address(item, "origin"),
        destination: self.address(item, "destination"),
        css_class: self.cssClasses(loadState),
        selected: self.props.selectedLoadStateId === loadState.id,
        references: this.references(item),
        loadState,
        id: loadState.id
      };
    }.bind(this));
  },
  rowChanged: function(item) {
    if (item.selected) {
      this.props.onSelectionChange(void 0);
    } else {
      this.props.onSelectionChange(item.loadState);
    }
  },
  tdClassName: function(itemAttribute, item) {
    if (itemAttribute == "carrier_name" && this.props.loadsNotFromEmailCarrier(item.loadState)) {
      return "load-list__nonmatching-carrier";
    }
  },
  table: function(items) {
    var rows = [];
    if (!_.isEmpty(items)) {
      var summaryCells = function(x) {
        return this.columnNames().map(function(c) {
          return /* @__PURE__ */ React.createElement("td", { key: c, className: this.tdClassName(c, x) }, x[c]);
        }, this);
      }.bind(this);
      items.forEach(function(item, idx) {
        var clicker = function() {
          this.rowChanged(item);
        }.bind(this);
        var cells = summaryCells(item);
        rows.push(
          /* @__PURE__ */ React.createElement("tr", { key: item.id, className: item.css_class }, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("input", { onChange: clicker, checked: item.selected, type: "checkbox", className: "mousetrap" })), cells)
        );
        if (item.selected || items.length === 1) {
          rows.push(
            /* @__PURE__ */ React.createElement("tr", { key: item.id + "_detail", className: item.css_class }, /* @__PURE__ */ React.createElement("td", null, "\xA0"), /* @__PURE__ */ React.createElement("td", { colSpan: cells.length }, /* @__PURE__ */ React.createElement("div", { className: "import-detail__reference-header" }, "References"), /* @__PURE__ */ React.createElement(
              HoverableValueTable,
              {
                items: this.referencesFor(item),
                onValueHighlighted: this.props.highlightChanged
              }
            )))
          );
        }
      }.bind(this));
    } else {
      rows.push(
        /* @__PURE__ */ React.createElement("tr", { key: "no_items" }, /* @__PURE__ */ React.createElement("td", { colSpan: "8" }, /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, /* @__PURE__ */ React.createElement("em", null, "No matching loads found in TMS data received by TriumphPay Audit."))))
      );
    }
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("table", { cellSpacing: "0", className: this.state.cssClass }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { className: "header" }, /* @__PURE__ */ React.createElement("th", null), this.header())), /* @__PURE__ */ React.createElement("tbody", null, rows)));
  },
  columnNames: function() {
    return Object.keys(this.state.config.columns);
  },
  allowedReferenceFields() {
    const settings = Account.currentSettings() || {};
    return settings.tms_reference_fields || [];
  },
  referencesFor(item) {
    const allowedReferenceFields = this.allowedReferenceFields();
    var selectedReferences = void 0;
    if (_.isEmpty(allowedReferenceFields)) {
      selectedReferences = item.references;
    } else {
      selectedReferences = _.chain(allowedReferenceFields).map((field) => item.references.filter((ref) => ref.name === field)).flatten().value();
    }
    if (item.origin) {
      selectedReferences.push({ "name": "Origin", "value": item.origin, "hoverable": true });
    }
    if (item.destination) {
      selectedReferences.push({ "name": "Destination", "value": item.destination, "hoverable": true });
    }
    return selectedReferences;
  },
  header: function() {
    return this.columnNames().map(function(c) {
      return /* @__PURE__ */ React.createElement("th", { key: c, className: "header " }, this.state.config.columns[c].name);
    }, this);
  },
  render: function() {
    var items = this.format(this.props.items);
    return /* @__PURE__ */ React.createElement("div", null, this.table(items));
  }
});
export default LoadTable;
